var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.5 -1.5 48 48",
    strokeWidth: 3,
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-square--change-document-edit-modify-paper-pencil-write-writing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 62",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M39.269 15.409c1.817 -1.818 2.509 -4.475 0.958 -6.525A21.019 21.019 0 0 0 38.306 6.694a21.135 21.135 0 0 0 -2.19 -1.922c-2.05 -1.55 -4.707 -0.858 -6.525 0.959L15.119 20.204c-0.51 0.51 -0.86 1.157 -0.928 1.875 -0.118 1.217 -0.226 3.492 0.021 7.023a1.819 1.819 0 0 0 1.687 1.687c3.531 0.247 5.806 0.139 7.024 0.022 0.717 -0.069 1.364 -0.419 1.874 -0.928l14.473 -14.473Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M37.076 17.602c-0.536 -1.186 -1.695 -3.197 -4.088 -5.59 -2.393 -2.392 -4.403 -3.551 -5.589 -4.088",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1096",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M40.306 21.563c0.005 0.607 0.007 1.231 0.007 1.875 0 6.433 -0.236 10.974 -0.466 13.867 -0.19 2.396 -2.021 4.226 -4.417 4.416 -2.893 0.231 -7.434 0.467 -13.867 0.467s-10.974 -0.236 -13.867 -0.466c-2.396 -0.19 -4.226 -2.021 -4.416 -4.417C3.048 34.412 2.813 29.871 2.813 23.438s0.236 -10.974 0.466 -13.867C3.469 7.174 5.299 5.344 7.695 5.154 10.588 4.923 15.129 4.688 21.563 4.688c0.644 0 1.268 0.003 1.875 0.007",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.fa8d278b0477be9bd7d63c0659f4d0d2.svg";
export { ForwardRef as ReactComponent };